import React, { useEffect, useState } from 'react'
import ColumnChartComponent from './ratingChart'
import styles from '../../../assets/stats.module.css'
import TableChartComponent from './topicTable';
import PieChartTopics from './piechart';
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import { Dropdown ,DropdownButton, Pagination} from "react-bootstrap";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { compareUserStatistcs, getuserStatistcs } from '../../../store/actions/userActions';
import Loader from '../../Common/Loading';

const Stats = () => {
  
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location=useLocation();

  const userName=location.pathname.split('/')[2]
  const friendUserName=location.pathname.split('/')[3]
  const [selectedPlatform,setSelectedPlatform]=useState("Codeforces")
  const users=useSelector(state=>Object(state.home).users)
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const handlePlatformChange = (platform) => {
    setSelectedPlatform(platform);
  }
  const userData=useSelector(state=>Object(state.auth))
  const [searchTerm, setSearchTerm] = useState(friendUserName===undefined?'':friendUserName);
  const [userFound, setuserFound] = useState(friendUserName===undefined?false:true);
  const filteredUsers = userFound===true || searchTerm==='' ?[]:users.filter(user =>
    user.userName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleInputChange = event => {
    if(userFound)setuserFound(false)
    setSearchTerm(event.target.value);
  };

  const dispatch=useDispatch()
  const navigate=useNavigate()
  const userStats=useSelector((state)=>(Object(state.topics.userStats)))
  useEffect(()=>{
    if(userStats!==undefined && userStats!==null && userName===userStats["userName"])return;
    if(friendUserName===undefined || friendUserName===null)dispatch(getuserStatistcs(userName,navigate))
    else dispatch(compareUserStatistcs(userName,friendUserName,navigate))
  },[])

  const close=()=>{
    navigate(`/profile/${userName}`)
  }
  const compare=()=>{
    navigate(`/stats/${userData.userName}/${searchTerm}`)
  }
  return (
    <div className={`${styles.statsContainer} container-fluid`}>
      <nav className="navbar navbar-expand-lg navbar-dark" style={{backgroundColor:"#1a1a1a"}}>
      <div className="container">
        <div>
        <h4 style={{color:"white"}}>
          {`${selectedPlatform} Statistics`}
        </h4>
        </div>
        <div className='d-flex justify-content-between'>
        <form className="d-flex mx-auto align-items-center">
          <div className='d-flex flex-column me-2' style={{position:"relative"}}>
          <input className="form-control " style={{height:"38px"}} type="search" placeholder="User id" value={searchTerm}
        onChange={handleInputChange} />
        <div className={styles["user-list"]} >
        {filteredUsers.map((user, index) => (
          <div key={index} className={styles["user-item"]} onClick={()=>{setuserFound(true);setSearchTerm(user.userName)}}>
            {user.userName}
          </div>
        ))}
      </div>
      </div>
          <button className="btn btn-outline-success mb-2" style={{height:"38px",marginRight:"20px"}} onClick={()=>compare()}>Compare</button>
        </form>
        <div>
        {/* <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle caret className={`${styles.maindropdown} `} style={{backgroundColor:"#555555"}}>
                {selectedPlatform}
            </DropdownToggle>
            <DropdownMenu style={{backgroundColor:"#3a3a3a",color:"white"}}>
                <DropdownItem   className={selectedPlatform== "Codeforces" ? styles["red-text"] : styles["white-text"]}   onClick={() => handlePlatformChange("Codeforces")}>Codeforces</DropdownItem>
            <DropdownItem  className={selectedPlatform== "LeetCode"? styles["red-text"] : styles["white-text"]}   onClick={() => handlePlatformChange("Atcoder")}>Atcoder</DropdownItem>
            </DropdownMenu>
        </Dropdown> */}
        </div>
        <div>
        <button
          type="button"
          className="btn btn-link text-white"
          aria-label="Close"
          onClick={()=>close()}
        >
          <FontAwesomeIcon icon={faTimes} fontSize={25}/>
        </button>
        </div>
        </div>
      </div>
    </nav>
    {userData.loading && <Loader/>}
      <div className='row'>
        <div className='col-12 col-md-6 mt-3'>
        <ColumnChartComponent friend={friendUserName===undefined?false:true} data={friendUserName===undefined?userStats["index"]:userStats["user"]===undefined?undefined:userStats["user"]["index"]} userName={userName} friendName={friendUserName} friendsData={friendUserName===undefined?[]:userStats["friend"]===undefined?undefined:userStats["friend"]["index"]} title="Problems VS Level"/>
        </div>
        <div className='col-12 col-md-6 mt-3'>
        <ColumnChartComponent friend={friendUserName===undefined?false:true} data={friendUserName===undefined?userStats["contextType"]:userStats["user"]===undefined?undefined:userStats["user"]["contextType"]} userName={userName} friendName={friendUserName} friendsData={friendUserName===undefined?[]:userStats["friend"]===undefined?undefined:userStats["friend"]["contextType"]} title="Problems VS Contexttype"/>
        </div>
        <div className='col-12 col-md-6'>
      <TableChartComponent userName={userName} friendName={friendUserName}topics={friendUserName===undefined?userStats["topics"]:userStats["friend"]===undefined?undefined:userStats["user"]["topics"]} friendtopics={friendUserName===undefined?undefined:userStats["friend"]===undefined?undefined:userStats["friend"]["topics"]}/>
      </div>
      <div className='col-12 col-md-6 mt-3'>
      <PieChartTopics friendName={friendUserName} topics={friendUserName===undefined?userStats["topics"]:userStats["friend"]===undefined?undefined:userStats["friend"]["topics"]}/>
      </div>
      <div className='m-3 col-12 col-md-10'>
      <ColumnChartComponent friend={friendUserName===undefined?false:true} data={friendUserName===undefined?userStats["rating"]:userStats["user"]===undefined?undefined:userStats["user"]["rating"]} userName={userName} friendName={friendUserName} friendsData={friendUserName===undefined?[]:userStats["friend"]===undefined?undefined:userStats["friend"]["rating"]} title="Problems VS Rating"/>
        </div>
      </div>
    </div>
  )
}

export default Stats